module.exports = __webpack_public_path__ + "cae09fd12840d6bb7fdae70d45234c45.svg";